import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import { ActionInterface } from "../../Interface/ActionInterface";
import Auth from "../../Auth/Auth";
import Translator from "../../Translation/Translator";
import ForgotPasswordActions from "../../Action/Actions/ForgotPasswordActions";

export default function* forgotPassword(action: ActionInterface): any {
  try {
    const user = yield call(Auth.forgotPassword, action.payload?.user);
    yield put(ForgotPasswordActions.success(user));

    // CASA-8583
    yield put({
      type: Constants.SNACKBAR_ADD_MESSAGE,
      payload: {
        message: Translator.trans("reset-email-sent"),
        type: "success"
      }
    });
  } catch (err) {
    yield ErrorHandlerSequence(err, action);
    yield put(ForgotPasswordActions.failure(err));
    yield put(ForgotPasswordActions.openPopup(err.translatedMessage));
  }
}

export function* watchForgotPassword() {
  yield takeEvery(Constants.PAGE_FORGOT_PASSWORD_REQUEST, forgotPassword);
}
